import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SavyIcon from "../../../../../../src/assets/icons/savy.png";
import { useParams } from "react-router-dom";
import axios from "axios";
import { message } from "antd";
import {
  createRefundEstimation,
  REFUND_FLOW_ID,
} from "./refundEstimationApi";

const Welcome = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [isAnimating, setIsAnimating] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Start animations after component mounts
    setTimeout(() => setIsAnimating(true), 100);
  }, []);

  const handleButtonClick = (e) => {
    // Add ripple effect
    const button = e.currentTarget;
    const ripple = document.createElement("span");
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    ripple.classList.add("ripple");

    button.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);

    handleNext();
  };

  const handleNext = async () => {
    // Start exit animation
    setIsExiting(true);

    try {
      if (id === REFUND_FLOW_ID) {
        // Refund flow: create refund estimation
        const data = await createRefundEstimation();
        const refundEstimationId = data.id || data._id;
        if (refundEstimationId) {
          localStorage.setItem("refundEstimationId", refundEstimationId);
        }
        // Clear old estimation when starting refund flow
        localStorage.removeItem("estimationId");
      } else {
        // Savings / other flow: create old estimation
        const payload = {
          startDate: new Date().toISOString(),
          user: "6899eb6eebdd7e9cc42384da",
          income: null,
          source: "Mobile app",
          status: "In progress",
          ownCar: null,
          mileage: null,
          mileageRate: null,
          foodAndDrink: null,
          daysPerWeek: null,
          reimbursedPerDay: null,
          annualSaving: null,
          trialStarted: null,
          refundYears: 0,
          refund: null,
          onBoardingStatut: null,
          timeSpent: 0,
          mileageType: 0,
          spendPerDay: 0,
          annualExpenses: 0,
        };

        const response = await axios.post(
          "https://api.savyapp.dev/api/v1/estimations/user/me",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Estimation created:", response.data);
        const estimationId = response.data.id;
        localStorage.setItem("estimationId", estimationId);
      }

      // Wait for exit animation before navigating
      setTimeout(() => {
        navigate(`/preview/flow/${id}/question`);
      }, 300);
    } catch (error) {
      console.error("Error creating estimation:", error);
      setIsExiting(false);
      message.error("Failed to start. Please try again.");
    }
  };

  return (
    <div
      className={`flex flex-col h-full bg-white transition-all duration-500 ${
        isExiting ? "opacity-0 scale-95" : "opacity-100 scale-100"
      }`}
      style={{
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "calc(env(safe-area-inset-bottom) + 20px)",
      }}
    >
      {/* Main Content - Match mobile StartWizard copy and layout */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 sm:px-6 md:px-8 min-h-0">
        <div className="w-full max-w-2xl mx-auto flex flex-col text-left space-y-6 sm:space-y-8">
          {/* 1. Welcome to + Logo (mobile: welcomeText + SavyLogo) */}
          <div
            className={`flex flex-col items-center transition-all duration-700 ease-out ${
              isAnimating ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
            style={{ transitionDelay: "100ms" }}
          >
            <p className="text-lg sm:text-xl md:text-2xl font-bold text-[#6B7280] mb-0">
              Welcome to
            </p>
            <div className="py-5 sm:py-6">
              <img
                src={SavyIcon}
                alt="Savy"
                className="w-auto h-10 sm:h-12 md:h-14 lg:h-16 max-w-[200px] sm:max-w-[240px] md:max-w-[280px]"
              />
            </div>
          </div>

          {/* 2. We help taxpayers get refunds for work travel costs. (mobile bodyBlock) */}
          <div
            className={`transition-all duration-700 ease-out ${
              isAnimating ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
            style={{ transitionDelay: "300ms" }}
          >
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 leading-tight">
              We help taxpayers{" "}
              <span className="bg-gradient-to-r from-[#87ACFD] via-[#BE6ED4] to-[#F28789] bg-clip-text text-transparent">
                get refunds
              </span>
              {" "}for work{" "}
              <span className="block sm:inline">travel costs.</span>
            </h1>
          </div>

          {/* 3. Give us 30 seconds and we'll tell you how much you can get back. (mobile secondsBlock) */}
          <div
            className={`pt-6 sm:pt-8 transition-all duration-700 ease-out ${
              isAnimating ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
            style={{ transitionDelay: "500ms" }}
          >
            <p className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 leading-tight">
              Give us{" "}
              <span className="bg-gradient-to-r from-[#BE6ED4] to-[#F28789] bg-clip-text text-transparent">
                30 seconds
              </span>
              <br className="sm:hidden" />
              {" "}and we'll tell you
              <br className="sm:hidden" />
              {" "}how much you can
              <br className="sm:hidden" />
              {" "}get back.
            </p>
          </div>
        </div>
      </div>

      {/* Footer Button - mobile: "Start" */}
      <div className="w-full px-4 sm:px-6 md:px-8 py-4 sm:py-5 bg-white flex-shrink-0">
        <div className="max-w-2xl mx-auto">
          <button
            onClick={handleButtonClick}
            className={`w-full bg-[#002147] text-white font-semibold py-2.5 sm:py-3 rounded-lg hover:bg-[#003366] focus:bg-[#003366] focus:outline-none focus:ring-2 focus:ring-[#002147]/30 shadow-md hover:shadow-lg transform hover:scale-[1.01] active:scale-[0.99] relative overflow-hidden transition-all duration-200 ${
              isAnimating
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-4"
            }`}
            style={{
              transitionDelay: "1300ms",
            }}
          >
            <span className="relative z-10">Start</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
